import { compose } from 'recompose';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { bindActionCreators } from 'redux';
import ClickOutside from 'react-click-outside';

import { mainTransition } from 'ggApp/modules/router/actions';
import { closeOverlay, openOverlay } from 'ggApp/modules/overlay/actions';
import {
    locationPathname as locationPathnameSelector,
    overlayIsOpen,
} from 'ggApp/modules/router/selectors';
import { activeJson as activeFiltersSelector } from 'ggApp/modules/filter/selectors';
import {
    fetchProductsForSearch,
    fetchDefaultProductsForSearch,
} from 'ggApp/modules/search/actions';
import { storeActive } from 'ggApp/modules/store';
import { loading as isLoadingSelector } from 'ggApp/modules/search/selectors';
import { registerSearchOverlayEvent } from 'ggApp/modules/gaAnalytics/actions';
import Bar from './Bar';

const enhance = compose(
    connect(
        createStructuredSelector({
            overlayIsOpen,
            filters: activeFiltersSelector,
            locationPathname: locationPathnameSelector,
            isLoading: isLoadingSelector,
            storeActive,
        }),
        (dispatch) => ({
            openOverlay: bindActionCreators(openOverlay, dispatch),
            closeOverlay: bindActionCreators(closeOverlay, dispatch),
            fetchProductsForSearch: bindActionCreators(fetchProductsForSearch, dispatch),
            fetchDefaultProductsForSearch: bindActionCreators(
                fetchDefaultProductsForSearch,
                dispatch,
            ),
            mainTransition: bindActionCreators(mainTransition, dispatch),
            registerSearchOverlayEvent: bindActionCreators(registerSearchOverlayEvent, dispatch),
        }),
    ),
    ClickOutside,
);

export default enhance(Bar);
